import React, { createContext, useState } from 'react';

export const NotificationsContext = createContext({});

export const NOTIFICATION_PLACEMENT = {
  BOTTOM_LEFT: {
    vertical: 'bottom',
    horizontal: 'left'
  },
  TOP_CENTER: {
    vertical: 'top',
    horizontal: 'center'
  }
};

export const NOTIFICATION_SEVERITY = {
  ERROR: 'danger',
  WARNING: 'warning',
  INFO: 'information',
  SUCCESS: 'success'
};

export const NotificationsProvider = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);

  const defaultConfig = {
    message: '',
    type: NOTIFICATION_SEVERITY.WARNING
  };

  const [alertConfig, setAlertConfig] = useState(defaultConfig);

  const clearNotification = () => {
    setIsOpen(false);
  };

  const autoClearNotification = () => {
    window.setTimeout(clearNotification, 5000);
  };

  /**
   * Creates and shows notification with Alert
   * @param {string} config.message
   * @param {string} config.severity one of NOTIFICATION_SEVERITY
   * @param {Object} config.placement one of NOTIFICATION_PLACEMENT
   * @param {number} config.autoHideDuration
   */
  const showNotification = (config, disableAutoClear) => {
    setAlertConfig({
      ...defaultConfig,
      ...config
    });
    setIsOpen(true);
    if (!disableAutoClear) {
      autoClearNotification();
    }
  };

  const showError = (message, disableAutoCleare) => {
    showNotification({
      message,
      type: NOTIFICATION_SEVERITY.ERROR
    },
    disableAutoCleare
    );
  };

  const showInfo = (message, disableAutoClear) => {
    showNotification({
      message,
      type: NOTIFICATION_SEVERITY.INFO
    },
    disableAutoClear
    );
  };

  const showSuccess = (message, disableAutoClear) => {
    showNotification({
      message,
      type: NOTIFICATION_SEVERITY.SUCCESS
    },
    disableAutoClear
    );
  };

  return (
    <>
      <NotificationsContext.Provider
        value={{
          isOpen, alertConfig, showNotification, showError, showInfo, clearNotification, showSuccess
        }}
      >
        {children}
      </NotificationsContext.Provider>
    </>
  );
};
